import { put } from 'core/middlewares/utilities';
import { QueryOptions } from 'core/domains/catalog';
import { AvailableShowcases } from 'core/services/bff';
import { showcases as showcasesSelectors } from '../../helpers/selectors';
import { catalog } from 'core/use-cases';
import { fetchShowcases } from './fetch-showcases';
import { AVAILABLE_OPTION } from 'core/domains/catalog.d';
import { getLocationPathname } from 'core/utilities';
/**
 * reset products when Shipping Model changes flow
 *
 */
export function* resetProducts() {
  const pathname = getLocationPathname();
  const { search } = window.location;
  const splittedPathname = pathname?.split('/');
  const isHomeView = pathname.includes('departamentos') && splittedPathname?.length <= 2;
  const queryOptions = {
    itemsPerPage: Number(16),
    availability: AVAILABLE_OPTION.first,
  } as QueryOptions;

  if (isHomeView) {
    const availableShowcases: AvailableShowcases[] =
      yield showcasesSelectors.getAvailableShowcases();

    yield fetchShowcases(availableShowcases);
    return;
  }

  const isDepartamentView = pathname.includes('departamentos') && splittedPathname?.length > 2;
  const isTagSearch = search.includes('tag=');
  const isProductSearch = search.includes('q=');
  const term = search.split('=')[1];

  if (isDepartamentView) {
    queryOptions.department = splittedPathname[splittedPathname.length - 1];
    queryOptions.category = term;
  }

  if (isTagSearch) {
    queryOptions.tag = term;
  }

  if (isProductSearch) {
    queryOptions.query = term;
  }

  yield put(catalog.actions.catalogFetch.request(queryOptions));
}
